import React, { Component } from 'react';
import { Link  } from 'react-router-dom';
import Countdown from "react-countdown";
import '../static/css/WelcomeCS.css';
import logo from '../static/images/images/Motorcyk_SSa-R03a_Mil.png';
import blogOne from '../static/images/images/motorcyk-motorcycle-blog-one2.jpg';
import blogTwo from '../static/images/images/mototrcyk-motorcyclist-rider-blog-two.jpg';
import blogThree from '../static/images/images/motorcyk-motorcycle-community.jpg';
import blogFour from '../static/images/images/motorcyk-electric-motorcycle.jpg';
import blogFive from '../static/images/images/motorcyk-motorcycle-ducati-profile-main.jpg';
import Instagram from '../static/images/images/instagram.svg';
import Facebook from '../static/images/images/facebook.svg';
import Twitter from '../static/images/images/twitter.svg';
import Pinterest from '../static/images/images/pinterest.svg';
import Youtube from '../static/images/images/youtube.svg';
import Rumble from '../static/images/images/rumble.svg';
class WelcomeCS extends Component {
    constructor() {
        super()
        this.state = {
            email: '',
            status: 'idle',   // idle | submitting | success | error
            message: '',
        };
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    };
    onChangeEmail(event) { this.setState({ email: event.target.value }) };
    // Post straight to Mailchimp via JSONP — no backend needed, avoids CORS, stays on page.
    subscribe(email) {
        return new Promise((resolve, reject) => {
            const callback = 'mcjsonp_' + Date.now();
            const script = document.createElement('script');
            let settled = false;
            // Mailchimp returns TWO callback calls for validation errors (invalid JS that
            // never parses), so a plain JSONP callback can hang forever. The timeout below
            // guarantees we always settle; `settled` makes the first outcome win.
            const finish = (fn, arg) => {
                if (settled) return;
                settled = true;
                clearTimeout(timer);
                window[callback] = () => {}; // absorb any stray second call instead of throwing
                if (script.parentNode) script.parentNode.removeChild(script);
                setTimeout(() => { try { delete window[callback]; } catch (e) {} }, 2000);
                fn(arg);
            };
            window[callback] = (data) => finish(resolve, data);
            const timer = setTimeout(() => finish(reject, new Error('timeout')), 7000);
            const params = new URLSearchParams({
                u: '03e857ffff13b852445c1cb7e',
                id: '4591c883cc',
                f_id: '00e468e9f0',
                EMAIL: email,
                'b_03e857ffff13b852445c1cb7e_4591c883cc': '', // honeypot — must stay empty
            });
            script.src = 'https://motorcyk.us12.list-manage.com/subscribe/post-json?' + params.toString() + '&c=' + callback;
            script.onerror = () => finish(reject, new Error('network'));
            document.body.appendChild(script);
        });
    };
    async onSubmit(event) {
        event.preventDefault();
        const email = this.state.email.trim();
        const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (!validEmail) {
            this.setState({ status: 'error', message: 'Please enter a valid email.' });
            return;
        };
        this.setState({ status: 'submitting', message: '' });
        try {
            const data = await this.subscribe(email);
            const already = /already subscribed/i.test(data.msg || '');
            if (data.result === 'success') {
                this.setState({
                    status: 'success',
                    email: '',
                    message: already
                        ? "You're already on the list! 🏍️ We'll email you the moment the app drops."
                        : "You're on the list! We'll email you the moment the app drops. Ride safe 😎",
                });
            } else {
                this.setState({ status: 'error', message: 'Hmm, that didn\'t go through — please try again.' });
            };
        } catch (e) {
            this.setState({ status: 'error', message: "That email couldn't be added — please double-check it and try again." });
        };
    };
    render() {
        const Completionist = () => <span style={{color: "#FF2F46", fontSize: "20px"}}>We will be live shortly!</span>;
        const renderer = ({ days, hours, minutes, seconds, completed }) => {
            if (completed) {
              return <Completionist />;
            } else {
              return (
                <span>
                    <h2 className="welcomecs-countdown-style r">{days} <br/> <span style={{fontSize:"12px"}}>Days</span> </h2><h2 className="welcomecs-countdown-style r">:</h2><h2 className="welcomecs-countdown-style r">{hours} <br/> <span style={{fontSize:"12px"}}>Hours</span> </h2><h2 className="welcomecs-countdown-style r">:</h2><h2 className="welcomecs-countdown-style r">{minutes} <br/> <span style={{fontSize:"12px"}}>Minutes</span> </h2><h2 className="welcomecs-countdown-style r">:</h2><h2 className="welcomecs-countdown-style r">{seconds} <br/> <span style={{fontSize:"12px"}}>Seconds</span></h2>
                </span>
              );
            }
        };
        return (
            <div className="container">
                {/* <div className="header">
                    <h5 className="header-title"><img className="header-logo" src={logo} alt="" /></h5>
                </div> */}
                <div className="main-image-container">
                    <h5 className="header-title"><img className="header-logo" src={logo} alt="" /></h5>
                    <br />
                    <div className="welcomecs-intro-content-container">
                        <h3>Ride with real people.</h3>
                        <br />
                        <h1 className="r">Motorcyk Is<br/>Returning Soon</h1>
                        <br />
                        <h4>Find local ride meetups, meet riders you actually vibe with, and show up. Built for real-world riding—not just routes and stats.</h4>
                    </div>
                    <div className="welcomecs-email-launch-notification-form-container">
                        <p><u>Get Notified When The App Drops:</u></p>
                        { this.state.message ? <p className="r">{this.state.message}</p> : null }
                        <form onSubmit={this.onSubmit}>
                            <input style={{width: "225px", marginBottom:"10px"}} type="email" placeholder="Enter email..." value={this.state.email} onChange={this.onChangeEmail} disabled={this.state.status === 'submitting'}/>
                            <button style={{width: "250px", marginBottom:"10px"}} type="submit" disabled={this.state.status === 'submitting'}>{this.state.status === 'submitting' ? 'Submitting...' : 'Notify Me'}</button>
                        </form>
                    </div>
                    <div className="welcomecs-footer-follow-soon-container">
                        <div className="welcomecs-footer-follow-soon-icons-container">
                            <h4 className="welcomecs-footer-follow-soon-icons-title">GIVE US A FOLLOW</h4>
                            <div className="welcomecs-footer-follow-soon-icons">
                                <a className="welcomecs-footer-follow-soon-icon" href="https://www.instagram.com/motorcyk/" target="_blank" rel="noopener noreferrer"><img className="welcomecs-footer-follow-social-icon" src={Instagram} alt="Motorcyk's Instagram link for motorcyle enthusists"/></a> 
                                <a className="welcomecs-footer-follow-soon-icon" href="https://www.facebook.com/motorcyk" target="_blank" rel="noopener noreferrer"><img className="welcomecs-footer-follow-social-icon" src={Facebook} alt="Motorcyk's Facebook page link for motorcyle enthusists"/></a> 
                                <a className="welcomecs-footer-follow-soon-icon" href="https://twitter.com/motorcyk" target="_blank" rel="noopener noreferrer"><img className="welcomecs-footer-follow-social-icon" src={Twitter} alt="Motorcyk's Twitter link for motorcyle enthusists"/></a> 
                                <a className="welcomecs-footer-follow-soon-icon" href="https://www.pinterest.com/motorcyk" target="_blank" rel="noopener noreferrer"><img className="welcomecs-footer-follow-social-icon" src={Pinterest} alt="Motorcyk's Pinterests profile link for motorcyle enthusists"/></a> 
                                <a className="welcomecs-footer-follow-soon-icon" href="https://www.youtube.com/channel/UC74mB3afir3CvrF3NdDjc2w?sub_confirmation=1" target="_blank" rel="noopener noreferrer"><img className="welcomecs-footer-follow-social-icon" src={Youtube} alt="Motorcyk's Youtube channel link for motorcyle enthusists"/></a> 
                                <a className="welcomecs-footer-follow-soon-icon" href="https://rumble.com/c/c-2134132" target="_blank" rel="noopener noreferrer"><img className="welcomecs-footer-follow-social-icon" src={Rumble} alt="Motorcyk's Rumble channel for motorcyle enthusists"/></a> 
                            </div>
                        </div>
                    </div>
                    <p className="welcomecs-footer-bottom-title" style={{color: "white"}}><span className="welcomecs-footer-bottom-title-title w">2026 Motorcyk LLC</span><Link to={"/privacy-read"} className="welcomecs-footer-bottom-title-link no-dec w">Privacy</Link></p>
                </div>
            </div>
        );
    };
};
export default WelcomeCS;

